// Optimized font loading with preconnect and font-display swap
export const loadFonts = () => {
  // Create preconnect links for Google Fonts
  const preconnectGoogle = document.createElement('link');
  preconnectGoogle.rel = 'preconnect';
  preconnectGoogle.href = 'https://fonts.googleapis.com';
  
  const preconnectGstatic = document.createElement('link');
  preconnectGstatic.rel = 'preconnect';
  preconnectGstatic.href = 'https://fonts.gstatic.com';
  preconnectGstatic.crossOrigin = 'anonymous';
  
  // Add preconnects to head
  document.head.appendChild(preconnectGoogle);
  document.head.appendChild(preconnectGstatic);
  
  // Load fonts with display=swap for better performance
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap';
  
  // Use requestIdleCallback for non-critical font loading
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      document.head.appendChild(fontLink);
    });
  } else {
    // Fallback to setTimeout for browsers that don't support requestIdleCallback
    setTimeout(() => {
      document.head.appendChild(fontLink);
    }, 1);
  }
};

// Critical CSS for initial render
export const criticalCSS = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  body {
    min-height: 100vh;
    background: #ffffff;
  }
  
  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .loading-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    z-index: 9999;
  }
  
  .loading-spinner {
    width: 48px;
    height: 48px;
    border: 4px solid #e5e7eb;
    border-top-color: #14b8a6;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;